export const greetings = (time: Date) => (time.getHours() >= 12 ? 'GoodEvening' : 'GoodMorning');
